import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { getTranslatedOptions } from '../../../../utils/translation'
import { IconChevron } from '../../../Icon'
import { PageActionsButtonAddEntity } from '../../../PageActionsButtonAddEntity'
import { ButtonIconSelectControl, ButtonSelect } from '../../../Select'

import {
  CALENDAR_VIEW_NEW_MENU_OPTIONS,
  CalendarViewNewItem,
  QA_NAME_CALENDAR_NEW_MENU,
} from './CalendarViewNewMenu.constants'

import * as styles from './CalendarViewNewMenu.module.css'

function CalendarViewNewMenu({ onSelectAppointment, onSelectTask }) {
  const { t } = useTranslation()

  const itemHandlers = {
    [CalendarViewNewItem.appointment]: onSelectAppointment,
    [CalendarViewNewItem.task]: onSelectTask,
  }

  function handleSelectItem({ value }) {
    itemHandlers[value]()
  }

  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      className={styles.CalendarViewNewMenu}
      controlProps={{
        Button: PageActionsButtonAddEntity,
        buttonProps: {
          afterIconProps: { Icon: IconChevron },
          qaName: QA_NAME_CALENDAR_NEW_MENU,
          text: t('Calendar.NewKey'),
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        maxWidthByRef: false,
      }}
      listProps={{
        className: styles.dropdown,
        headerProps: {
          Search: null,
        },
      }}
      options={getTranslatedOptions({
        options: CALENDAR_VIEW_NEW_MENU_OPTIONS,
        t,
      })}
      onSelectItem={handleSelectItem}
    />
  )
}

export default CalendarViewNewMenu
